import { render, staticRenderFns } from "./import-stock-in-by-product.vue?vue&type=template&id=c6606148&"
import script from "./import-stock-in-by-product.vue?vue&type=script&lang=js&"
export * from "./import-stock-in-by-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports